<template>
  <v-footer
    
    padless
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="orange">
        <!-- <strong class="subheading">Get connected with us on social networks!</strong> -->

        <v-spacer></v-spacer>

        <v-btn
          v-for="icon in icons"
          :key="icon"
          class="mx-4"
          dark
          icon
        >
          <v-icon size="24px">
            {{ icon }}
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-2 white--text text-center">
        <router-link to="/" tag="card">
       <img class="" :src="require('../assets/operationwise_logo.png')" height="30"/>
       </router-link>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-linkedin',
        'mdi-instagram',
      ],
    }),
  }
</script>
<style>

</style>